import { render, staticRenderFns } from "./DistributionDataElementPath.vue?vue&type=template&id=6872f193&scoped=true&"
import script from "./DistributionDataElementPath.vue?vue&type=script&lang=js&"
export * from "./DistributionDataElementPath.vue?vue&type=script&lang=js&"
import style0 from "./DistributionDataElementPath.vue?vue&type=style&index=0&id=6872f193&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6872f193",
  null
  
)

export default component.exports